import React, {useState} from 'react';
import {Link} from "react-router-dom";

import {AboutUsPageResult} from '../../../../server/routes/about-us.js'

interface AboutusProps {
    server: string;
    pageData: unknown;
}

export default function Aboutus({server, pageData}: AboutusProps) {

    const typedPageData = pageData as AboutUsPageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <div  className={ "app" }>
             <section className="section section-lg reports-body">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <h3 className="text-left mb-3">
                                <b>About Us</b>
                            </h3>
                        </div>
                    </div>    
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <h4 className="text-left mb-3">
                                <b>Who we are</b>
                            </h4>
                            <p>
                            WebTechSurvey was started in sunny California by two co-founders 
                            with many years of experience in data gathering and analysis.
                            </p>
                            <p>
                                What started as a project to detect web technologies used by 
                                websites led to creation of a powerful technographic solution 
                                that collects and analyzes websites and website technology data 
                                across millions of domains.                             </p>
                            <p>
                                Fast forward few years, and we grew into a distributed team 
                                spread across California, Europe and East Asia. We created a data
                                analytics platform used by our customers to find and share meaningful 
                                insights about websites and technologies with hundreds of data points 
                                and multiple data visualizations.
                            </p>
                        </div>
                    </div>       
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <h4 className="text-left mb-3">
                                <b>Contact us</b>
                            </h4>
                            <p>  Reach out to us anytime and we'll be happy to help:&nbsp; 
                                 <Link to={`/contact-us`} className="link-hover" >{`contact us`}</Link>	
                            </p>
                        </div>
                    </div>  
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                             <p> 
                              &nbsp;
                             </p>
                        </div>
                    </div>      
                </div> 
            </section>
   
        </div>
    )
}





